import {
	ClientConfig,
} from './config/ClientConfig'

export function isGlobalCasino(): boolean {
	if (!ClientConfig.IS_GLOBAL_CASINO_ENABLED) {
		return false
	}
	return document.cookie.indexOf(`platform=globalcasino.com`) !== -1
}

function getHost(): string {
	return window.location.host
}

export const getSupportEmail = (): string => {
	return 'support@globalpoker.com'
}

export const getLandingPage = (): string => {
	if (isGlobalCasino()) return ClientConfig.GC_LANDING_PAGE_URL
	return ClientConfig.LANDING_PAGE_URL
}

export const getSourceOfWealthFormUrl = (): string => {
	return ClientConfig.SOURCE_OF_WEALTH_FORM_URL
}

export const getGlobalPokerZenDeskPage = (): string => {
	return ClientConfig.GLOBAL_POKER_ZENDESK_URL
}

export const getHelpdeskRequestPage = (): string => {
	return ClientConfig.GLOBAL_POKER_HELPDESK_URL
}

export type Platform = 'globalpoker.com' | 'globalcasino.com'

export const getPlatform = (): Platform => {
	if (isGlobalCasino()) return 'globalcasino.com'
	return 'globalpoker.com'
}

const AUTH0_SETTINGS = {
	'audience': 'pok-services',
	'local': {
		'domain': 'pok-dev-local.eu.auth0.com',
		'client_ids': {
			'globalpoker.com': 'wC31GOIta6yurFt5kSJLEufR33JgWoQn',
			'globalcasino.com': 'XQxhX1ugFgkO6b8GN4FHcIZidQGY3h4G'
		}
	},
	'ci': {
		'domain': 'login.ci.test.auth.poker',
		'client_ids': {
			'globalpoker.com': 'Ouhix4PvIgkNSybf5vfhNn1a6LgjnAop',
			'globalcasino.com': 'XQxhX1ugFgkO6b8GN4FHcIZidQGY3h4G'
		}
	},
	'qc': {
		'domain': 'login.qc.test.auth.poker',
		'client_ids': {
			'globalpoker.com': 'tYeyr5bp4hef7mE76MLvjmqRayJwquIP',
			'globalcasino.com': 'd14Tf7uu7FCgnQLgJKNEoMHaGsaKa9uv'
		}
	},
	'prod': {
		'domain': 'login.auth.poker',
		'client_ids': {
			'globalpoker.com': 'Ir14vAJ4XE3D9XsiKZhb61gy1u5vyY4W',
			'globalcasino.com': 'vGhQvGxuLX8IWO4hAzTS7nrvLF7RTQg9'
		}
	}
}

export interface Auth0Settings {
    domain: string,
    clientId: string,
    audience: string,
}

export const getAuth0Settings = (): Auth0Settings => {
	return {
		domain: AUTH0_SETTINGS[ClientConfig.AUTH0_ENV].domain,
		clientId: AUTH0_SETTINGS[ClientConfig.AUTH0_ENV].client_ids[getPlatform()],
		audience: AUTH0_SETTINGS.audience,
	}
}
